export const SERVANT_CHANGE = 'SERVANT_CHANGE'
export const SERVANT_RANK_CHANGE = 'SERVANT_RANK_CHANGE'
export const SERVANT_AVATAR_CHANGED = 'SERVANT_AVATAR_CHANGED'
export const RANK_CHANGE = 'RANK_CHANGE'
export const FETCH_PARAGON = 'FETCH_PARAGON'



// WEBPACK FOOTER //
// ./src/reducers/servants/constants.js